module.exports = __webpack_public_path__ + "img/gw.ac73de7e.png";